import { render } from "./VideoTeleport.vue?vue&type=template&id=42380ec3&scoped=true"
import script from "./VideoTeleport.vue?vue&type=script&lang=js"
export * from "./VideoTeleport.vue?vue&type=script&lang=js"

import "./VideoTeleport.vue?vue&type=style&index=0&id=42380ec3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42380ec3"]])

export default __exports__